var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.heatmapData !== null)?_c('HeatmapLayer',{attrs:{"data":_vm.heatmapData,"gradient":_vm.heatmapGradient,"visible":_vm.heatmapVisible,"radius":0.01,"maxIntensity":50,"dissipating":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }